module.exports = __webpack_public_path__ + "static/media/Right legs11.d05dc505.png";